import { useState } from 'react';

const faqList = [
  {
    q: 'Что должен уметь руководитель в переговорах?',
    a: 'Руководитель должен уметь готовиться к переговорам, ясно формулировать позицию, выявлять интересы другой стороны, аргументировать свою точку зрения фактами и целями бизнеса, работать с возражениями и давлением, удерживать принципиальные позиции, управлять уступками и переводить разговор в конкретные договорённости со сроками и критериями результата.',
  },
  {
    q: 'Чем переговоры руководителя отличаются от переговоров менеджера?',
    a: 'Менеджер чаще защищает интересы конкретной сделки, клиента или проекта. Руководитель одновременно учитывает интересы компании и команды, финансовый результат, долгосрочные отношения, риски, ответственность, репутацию и последствия решения. У руководителя выше цена ошибки, поэтому он должен видеть переговоры не только как способ получить уступку, но и как инструмент управления.',
  },
  {
    q: 'Как руководителю отстаивать свою позицию?',
    a: 'Начинать с подготовки: определить, какая позиция принципиальна, а где есть пространство для договорённости. Затем аргументировать позицию через факты, цели бизнеса и последствия альтернативных решений, а не через давление или эмоции. Важно удерживать принципиальные требования, не поддаваясь на манипуляции, и одновременно сохранять управляемость ситуации.',
  },
  {
    q: 'Как руководителю договариваться с сильными сотрудниками?',
    a: 'Сильного сотрудника нельзя просто «поставить на место» — это приведёт к потере мотивации или уходу. Нужно одновременно удерживать требования и сохранять отношения: понимать, что стоит за позицией сотрудника, отделять его реальный интерес от заявленного, искать решения, учитывающие и интересы бизнеса, и интересы сотрудника, и при этом ясно обозначать границы и ответственность.',
  },
  {
    q: 'Как вести переговоры с собственником?',
    a: 'С собственником важно не просто высказать мнение, а сформировать позицию, аргументировать её цифрами и фактами и показать последствия альтернативных решений. Нужно говорить на языке результатов, ресурсов и рисков, заранее продумывать возможные возражения и предлагать варианты, а не только обозначать проблему.',
  },
  {
    q: 'Как руководителю реагировать на давление?',
    a: 'Алгоритм прост: остановиться, вернуть разговор к фактам, уточнить интересы другой стороны, обозначить свою позицию, определить границы допустимого, предложить варианты и зафиксировать договорённость. Главное — не поддаваться на эмоциональные реакции и манипуляции, сохранять рабочую позицию и контроль над собой.',
  },
  {
    q: 'Как не уступать слишком много в переговорах?',
    a: 'До начала переговоров определить, какие позиции принципиальны, а где уступка допустима. Каждая уступка должна что-то давать взамен, а не быть односторонним движением. Важно не делать уступки под эмоциональным давлением или из желания быстрее закончить разговор, и не превращать переговоры в спор, где главное — доказать свою правоту.',
  },
  {
    q: 'Как руководителю добиваться выполнения договорённостей?',
    a: 'Договорённость должна быть конкретной: действие, срок и критерий результата, а не общее обещание. Важно, чтобы стороны одинаково понимали, о чём договорились, и зафиксировать это. Затем руководитель проверяет выполнение в контрольной точке и при нарушении возвращается к ответственности сотрудника, а не молча переделывает за него.',
  },
  {
    q: 'Можно ли обучить руководителей переговорам?',
    a: 'Да, переговорные навыки — это практический навык, который отрабатывается. На обучении руководители не просто слушают теорию, а тренируются на реальных ситуациях: ролевые переговоры, переговорные дуэли, разбор кейсов, отработка аргументации и удержания позиции под давлением.',
  },
  {
    q: 'Для каких руководителей подходит программа?',
    a: 'Программа подходит собственникам бизнеса, генеральным и коммерческим директорам, руководителям подразделений, РОПам, руководителям среднего звена, топ-менеджерам и руководителям проектов — всем, кому приходится лично участвовать в ключевых переговорах и отстаивать интересы бизнеса.',
  },
  {
    q: 'Сколько длится обучение?',
    a: 'Корпоративный тренинг обычно занимает 1–2 дня практической работы. Модульная программа может длиться несколько недель с практикой между модулями, а комплексная управленческая программа — несколько месяцев. Точный формат и продолжительность определяются после диагностики задач компании.',
  },
  {
    q: 'Можно ли адаптировать программу под конкретную компанию?',
    a: 'Да, адаптация — обязательный этап. Сначала мы разбираемся, с какими переговорными ситуациями реально сталкиваются руководители: сложные сотрудники, переговоры с собственником, защита бюджета, конфликты между подразделениями. После этого программа настраивается под уровень участников и специфику бизнеса.',
  },
  {
    q: 'Можно ли добавить сопровождение после тренинга?',
    a: 'Да. После обучения при необходимости проводится сопровождение: разбираются реальные переговоры и сложные ситуации, возникшие в работе руководителей, корректируются действия и закрепляются навыки. При системной работе определяется, изменилось ли переговорное и управленческое поведение.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы о роли руководителя в переговорах
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}